import Snippet from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

const initialCodeState = {
  id: null,
  code: '',
  release: false
}

export default {
  namespaced: true,
  state: {
    snippets: [],
    filteredCollection: [],
    current: new Snippet(),
    currentCode: initialCodeState
  },
  getters: {
    getCollection: state => state.snippets,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.snippets.find(snippet => snippet.id === id),
    getCurrent: state => state.current,
    getCurrentCode: state => state.currentCode,
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      const id = payload.id
      delete payload.id
      return this.dispatch('get', {
        path: 'v1/snippets/theme/' + id,
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((snippet) => {
            commit('addSnippetToCollection', { snippetData: snippet })
            return getters.getById(snippet.id)
          })

          commit('addSnippetToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    getCode ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/snippets/' + id + '/code'
      }).then((res) => {
        commit('updateCurrentCode', res && res.body)
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/snippets',
        data: model.getJSON()
      }).then((res) => {

        commit('addSnippetToCollection', { snippetData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    update({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/snippets/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addSnippetToCollection', { snippetData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    delete({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/snippets/' + id
      }).then((res) => {

        commit('removeSnippetFromCollection', id)

        return res
      })
    },
    updateCode (store, payload) {
      return this.dispatch('put', {
        path: 'v1/snippets/' + payload.id + '/code',
        data: payload
      })
    }
  },
  mutations: {
    addSnippetToCollection(state, { snippetData, opts }) {
      addToCollection(this, state.snippets, snippetData, Snippet, opts)
    },
    addSnippetToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeSnippetFromCollection(state, snippetId) {
      const index = state.snippets.findIndex(el => el.id === snippetId)

      if (index === -1) {
        console.warn(`Could not find/delete snippet ${snippetId}`)
        return
      }

      state.snippets.splice(index, 1)
    },
    clearCollection(state) {
      state.snippets = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    updateCurrent (state, snippet) {
      state.current = snippet
    },
    updateCurrentCode (state, code) {
      state.currentCode = code
    },
    resetCurrent (state) {
      state.current = new Snippet()
    },
    resetCurrentCode (state) {
      state.currentCode = {...initialCodeState}
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/snippet/store.js